import { TranslationKeys } from '~frontend-common/i18n/english/car-creditor.i18n';

const keys: TranslationKeys = {
  carCreditor: {
    creditorName: {
      placeholder: 'ex. Banque Nationale',
      financed: {
        label: 'Nom du créancier',
        labelOther: 'Entrez le nom de la compagnie de financement',
      },
      leased: {
        label: 'Nom du locateur',
        labelOther: 'Entrez le nom de la compagnie de financement',
      },
    },
    creditorAddress: {
      placeholder: 'ex. 500 René-Lévesque Ouest, Montréal',
      label: 'Adresse du créancier',
    },
  },
};

export default keys;
